export enum RangeDatePickerTab {
  day = 'day',
  week = 'week',
  year = 'year',
  range = 'range',
}
